import React, {useState, useEffect, useContext, forwardRef, useRef} from "react";
import styles from "./Footer.module.css";
import WizardLogo from "../../assets/images/wizard-logo.png";
import { AppGlobalConfigContext } from "../../providers/AppGlobalConfigContext";
import {KeepPlayingOptions} from "../KeepPlayingOptions/KeepPlayingOptions";
import {LessonNavigationControls} from "../LessonNavigationControls/LessonNaviationControls";
import {useLessonNavigation} from "../../hooks/useLessonNavigation";

const Footer = forwardRef(({}) => {

    const { isEmbedMode } = useContext(AppGlobalConfigContext);
    const { keepPlaying, keepPlayingDelay, setKeepPlaying, setKeepPlayingDelay } = useLessonNavigation();

    const handleOptionsChange = (delay, enabled) => {
        setKeepPlaying(enabled);
        setKeepPlayingDelay(delay);
    }

    return (
        <div className={styles.footer}>

            {/*{Footer container with a flex layout, since the footer root must have a display:fixed to be always visible */}
            <div className={styles.contentContainer}>

                {!isEmbedMode &&
                    <div>
                        <img alt="footer" className={styles.footerLogo} src={WizardLogo} />
                    </div>
                }

                <KeepPlayingOptions className={styles.keepPlayingOptions}
                                    delay={keepPlayingDelay} autoPlayEnabled={keepPlaying} onPlayOptionsChange={handleOptionsChange}/>

                <LessonNavigationControls/>

            </div>
        </div>
    );
});

export default Footer;